import { captureErrorFx } from 'model/helpers/analytics.model';

const atob = window.atob;

function b64DecodeUnicode(str: string) {
	return decodeURIComponent(atob(str).replace(/(.)/g, function(m, p) {
		let code = p.charCodeAt(0).toString(16).toUpperCase();
		if (code.length < 2) {
			code = '0' + code;
		}
		return '%' + code;
	}));
}

function base64UrlDecode(str: string) {
	let output = str.replace(/-/g, '+').replace(/_/g, '/');
	switch (output.length % 4) {
		case 0:
			break;
		case 2:
			output += '==';
			break;
		case 3:
			output += '=';
			break;
		default:
			throw 'Illegal base64url string!';
	}

	try {
		return b64DecodeUnicode(output);
	} catch (err) {
		captureErrorFx(err);
		return atob(output);
	}
}

export function jwtDecode<T>(token: string): T {
	const payloadPosition = 1;

	return JSON.parse(base64UrlDecode(token.split('.')[payloadPosition]));
}
